/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the recipients of the message. It can be list of orgID, org_roles and service_roles
 */
export interface MessageRecipient { 
    /**
     * Recipient Org Ids
     */
    org_ids?: Array<string>;
    /**
     * Recipient Org Roles
     */
    org_roles?: Array<string>;
    /**
     * Recipient Service Roles
     */
    service_roles?: Array<string>;
    /**
     * Recipient Users
     */
    users?: Array<string>;
}

